/**
 * `next/link` shim wrapping react-router 7's `<Link>`. Same href API
 * (translated to RR7's `to`), same children-as-element pattern, same
 * `prefetch` / `replace` / `scroll` semantics where they map.
 */
import { forwardRef, type ReactNode } from 'react';
import { Link as RouterLink, type LinkProps } from 'react-router';

export interface NextLinkProps
  extends Omit<LinkProps, 'to' | 'prefetch'> {
  href: string;
  as?: string;
  prefetch?: boolean;
  shallow?: boolean;
  scroll?: boolean;
  locale?: string | false;
  legacyBehavior?: boolean;
  passHref?: boolean;
  children?: ReactNode;
}

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(function NextLink(
  {
    href,
    as: _as,
    prefetch,
    shallow: _shallow,
    scroll,
    locale: _locale,
    legacyBehavior: _legacyBehavior,
    passHref: _passHref,
    children,
    ...rest
  },
  ref
) {
  return (
    <RouterLink
      ref={ref}
      to={href}
      prefetch={prefetch === false ? 'none' : 'intent'}
      preventScrollReset={scroll === false}
      {...rest}
    >
      {children}
    </RouterLink>
  );
});

export default Link;
